var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("c-switcher", {
          attrs: { label: "Наличие медицинской книжки" },
          model: {
            value: _vm.form.medicalBook,
            callback: function ($$v) {
              _vm.$set(_vm.form, "medicalBook", $$v)
            },
            expression: "form.medicalBook",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("c-switcher", {
              attrs: { label: "Желаемая зарплата" },
              model: {
                value: _vm.form.salaryShow,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "salaryShow", $$v)
                },
                expression: "form.salaryShow",
              },
            }),
          ],
          1
        ),
        _c("transition", { attrs: { name: "slide" } }, [
          _vm.form.salaryShow
            ? _c(
                "div",
                { staticClass: "params" },
                [
                  _c("c-switcher", {
                    attrs: { type: "checkbox", label: "Обязательное" },
                    model: {
                      value: _vm.form.salaryRequired,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "salaryRequired", $$v)
                      },
                      expression: "form.salaryRequired",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
    _c(
      "div",
      [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("c-switcher", {
              attrs: { label: "Желаемый график работы" },
              model: {
                value: _vm.form.schedule.show,
                callback: function ($$v) {
                  _vm.$set(_vm.form.schedule, "show", $$v)
                },
                expression: "form.schedule.show",
              },
            }),
          ],
          1
        ),
        _c("transition", { attrs: { name: "slide" } }, [
          _vm.form.schedule.show
            ? _c(
                "div",
                { staticClass: "params" },
                [
                  _c("list-params", {
                    attrs: {
                      form: _vm.form.schedule,
                      "field-name": "График работы",
                      "field-type": _vm.fieldType,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("editDictionary", "schedule")
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
    _c(
      "div",
      [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("c-switcher", {
              attrs: { label: "Когда сможете приступить к работе" },
              model: {
                value: _vm.form.workStartShow,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "workStartShow", $$v)
                },
                expression: "form.workStartShow",
              },
            }),
          ],
          1
        ),
        _c("transition", { attrs: { name: "slide" } }, [
          _vm.form.workStartShow
            ? _c(
                "div",
                { staticClass: "params" },
                [
                  _c("c-switcher", {
                    attrs: { type: "checkbox", label: "Обязательное" },
                    model: {
                      value: _vm.form.workStartRequired,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "workStartRequired", $$v)
                      },
                      expression: "form.workStartRequired",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }